import React, { useState } from 'react';
import ContributorsList from './ContributorsList';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styles from '../styles/styles.module.scss';

const ContributorsSubHeader = () => {
  const [searchValue, setSearchValue] = useState('');

  return (
    <div className={styles.conListWrapper}>
      <div className={styles.conListSubHeader}>
        <Input
          style={{ width: 300 }}
          variant="filled"
          placeholder="Search by name"
          suffix={<SearchOutlined />}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </div>
      <div className={styles.conListContent}>
        <ContributorsList searchValue={searchValue} />
      </div>
    </div>
  );
};

export default ContributorsSubHeader;
